<template>
  <div id="app">
    <Job v-if="this.is_single_job" />
    <Jobs v-else />
  </div>
</template>

<script>
import Jobs from "./components/Jobs.vue";
import Job from "./components/Job.vue";

export default {
  name: "App",
  data() {
    return {
      job_id: "",
    };
  },
  computed: {
    is_single_job: function() {
      return this.job_id !== "" ? true : false;
    },
  },
  components: {
    Jobs,
    Job,
  },
  created() {
    this.job_id = wpLever.job_id; // eslint-disable-line
  },
};
</script>
